import { select } from '@ps/web-core-store';

import { getApolloClient } from '@swf/core/providers/ApolloClientProvider';
import store from '@swf/core/store';

const createNotificationServiceClient = (token: string) => {
  const { getState } = store;
  const state = getState();

  const { apiDomain = '' } = select.config.get(state);

  const wsUrl = new URL(apiDomain);
  wsUrl.protocol = 'wss';
  wsUrl.pathname = '/pam/notifications/subscription';

  const httpUrl = new URL(apiDomain);
  httpUrl.pathname = '/pam/notifications/graphql';

  const client = getApolloClient(httpUrl.href, wsUrl.href, token, {});

  return client;
};

export default createNotificationServiceClient;
